import { useNavigate } from 'react-router-dom';

import { runSearch } from '.';

export const useRunSearch = () => {
  const navigate = useNavigate();
  return (props: Omit<typeof runSearch, 'navigate'>) =>
    runSearch({ ...props, navigate });
};
